module.exports = __webpack_public_path__ + "static/media/wine_bundle.da65e337.jpeg";